export default "__VITE_ASSET__lXKE3v2s__"